<template>
  <div class="content-panel panel" compact>
    <div :class="title_classes">
      {{ branded_fare | capitalize }}
    </div>
    <div class="branded-fare-upsell__price">
      {{ formatted_price }} {{ item.price.currency }}
    </div>
    <div class="branded-fare-upsell__separator fullwidth"></div>

    <div class="branded-fare-upsell__amenity__top" v-if="true">
      <div class="branded-fare-upsell__amenity__icon">
        <vb-icon
          class="d-flex align-items-center justify-content-center"
          v-if="bag_amenity_info.icon"
          :name="bag_amenity_info.icon"
          :color="sass('primary')"
          :size="18"
        ></vb-icon>
      </div>
      <div class="branded-fare-upsell__amenity__name d-flex">
        {{ bag_amenity_info.txt }}: {{ bags_total }}
      </div>
    </div>
    <div class="branded-fare-upsell__separator fullwidth"></div>

    <div class="branded-fare-upsell__amenity__top" v-if="true">
      <div class="branded-fare-upsell__amenity__icon">
        <vb-icon
          class="d-flex align-items-center justify-content-center"
          v-if="services_amenity_info.icon"
          :name="services_amenity_info.icon"
          :color="sass('primary')"
          :size="18"
        ></vb-icon>
      </div>
      <div class="branded-fare-upsell__amenity__name d-flex">
        {{ services_amenity_info.txt }}: {{ included_services_count }}
      </div>
    </div>

    <div>
      <div
        class="branded-fare-upsell__show-all"
        v-b-modal="'modal-' + _uid + index"
      >
        Vedi tutti i servizi
      </div>

      <vb-modal
        :vb_options="{
          id: `modal-${_uid}${index}`,
          size: 'lg',
          title: 'Servizi inclusi',
          modal_class: 'branded-fare-upsell__modal',
          hide_footer: true,
        }"
      >
        <amenity
          class="branded-fare-upsell__amenity"
          v-for="(amenity, amenity_index) in filtered_amenities"
          :key="`amenities:${_uid}:${amenity_index}-all`"
          :item="get_amenity_info(amenity)"
        >
          <div
            class="branded-fare-upsell__amenity__wrapper"
            slot-scope="{ item }"
          >
            <div class="branded-fare-upsell__amenity__top">
              <div class="branded-fare-upsell__amenity__icon">
                <vb-icon
                  class="d-flex align-items-center justify-content-center"
                  v-if="item.icon"
                  :name="item.icon"
                  :color="sass('primary')"
                  :size="18"
                ></vb-icon>
              </div>
              <div class="branded-fare-upsell__amenity__text">
                <div
                  class="branded-fare-upsell__amenity__name d-flex"
                  v-if="item.txt"
                >
                  <div>{{ item.txt | capitalize }}</div>
                  <vb-icon
                    class="ml-1"
                    v-if="item.tooltip"
                    name="info"
                    :size="14"
                    v-b-popover.hover.top="item.tooltip"
                  />
                </div>
                <div
                  class="branded-fare-upsell__amenity__description"
                  v-if="item.description"
                >
                  {{ item.description | capitalize }}
                </div>
              </div>
            </div>
            <div class="branded-fare-upsell__separator fullwidth"></div>
          </div>
        </amenity>
      </vb-modal>
    </div>
    <div class="branded-fare-upsell__actions">
      <div>
        <!--flexbox-->
        <vb-button
          :vb_options="{
            variant: is_selected ? 'outline-info' : 'info',
            block: true,
            disabled: is_button_disabled,
            text: fare_button_text,
          }"
          @click="() => $emit('select-flight-offer', item)"
        >
        </vb-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  get_branded_fare,
  apply_markup_to_number,
  parse_flight_offer_bags,
  get_amenity_info,
  show_amenity,
  toggle_selected_class,
  get_fare_button_text,
} from "./logic";

export default {
  name: "branded-fare-upsell-swiper-item",
  components: {
    amenity: {
      render() {
        return this.$scopedSlots.default(this.$attrs);
      },
    },
  },
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
    selected_flight_offer_id: [String, Number],
    flight_offer_default: Object,
  },
  computed: {
    branded_fare() {
      return get_branded_fare(this.item);
    },
    formatted_price() {
      return apply_markup_to_number(this.item, this.item.price.grandTotal);
    },
    bag_amenity_info() {
      return get_amenity_info({ code: "0CH" });
    },
    bags_total() {
      return parse_flight_offer_bags(this.item).total;
    },
    services_amenity_info() {
      return get_amenity_info({ code: "", description: "Servizi inclusi" });
    },
    included_services_count() {
      return this.filtered_amenities.length;
    },
    filtered_amenities() {
      return this.item.travelerPricings[0].fareDetailsBySegment[0].amenities.filter(
        (a) => show_amenity(a),
      );
    },
    is_selected() {
      return this.item.id === this.selected_flight_offer_id;
    },
    is_button_disabled() {
      return this.is_selected && this.item.id === this.flight_offer_default.id;
    },
    fare_button_text() {
      return get_fare_button_text(
        this.item,
        this.selected_flight_offer_id,
        this.flight_offer_default,
      );
    },
    title_classes() {
      const modifier = toggle_selected_class(
        this.item,
        this.selected_flight_offer_id,
      );
      return `branded-fare-upsell-swiper-item__title branded-fare-upsell-swiper-item__title--${modifier}`;
    },
  },
  methods: {
    get_amenity_info,
  },
};
</script>

<style lang="scss" scoped>
.branded-fare-upsell-swiper-item {
  &__title {
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;
    text-transform: capitalize;
    &--selected {
      color: var(--primary);
    }
  }
}
</style>
